import Swal from "sweetalert2";

export const showNotitfication = (
  text: string,
  type: "success" | "error",
  showClose?: boolean
): void => {
  Swal.fire({
    text: text,
    icon: type,
    showConfirmButton: false,
    timer: showClose ? undefined : 3000,
    showCloseButton: showClose,
    customClass: {
      popup: "ac--font-expo",
    },
  });
};

/** Themed yes/no dialog. Resolves true only when the user confirms. */
export const confirmAction = async ({
  title,
  text,
  confirmText,
  cancelText,
}: {
  title: string;
  text?: string;
  confirmText: string;
  cancelText: string;
}): Promise<boolean> => {
  const themeColor =
    getComputedStyle(document.documentElement)
      .getPropertyValue("--ac-theme-primary")
      .trim() || "#3f0a35";

  const { isConfirmed } = await Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: themeColor,
    reverseButtons: true,
    focusCancel: true,
    customClass: {
      popup: "ac--font-expo",
    },
  });

  return isConfirmed;
};

export const scroll = (currentRef: any) => {
  setTimeout(() => {
    if (currentRef.current) {
      const element = currentRef.current;
      const offset = -150;
      const top =
        element.getBoundingClientRect().top + window.pageYOffset + offset;

      window.scrollTo({
        top: top,
        behavior: "smooth",
      });
    }
  }, 100);
};

export const convertFileToBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result?.toString().split(",")[1];
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};

export const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

export const openAntdNotification = (
  api: any,
  title: string,
  description: string,
  type: string
) => {
  api.destroy();
  api.open({
    type,
    duration: 2,
    placement: "bottomLeft",
    message: <span className="text-md-bold">{title}</span>,
    description: <span className="text-md-bold">{description}</span>,
    showProgress: true,
    pauseOnHover: false,
  });
};

export const stateColors: Record<string, string> = {
  new: "blue",
  confirmed: "green",
  progress: "orange",
  quality: "purple",
  quality_confirmed: "geekblue",
  done: "success",
  cancelled: "red",
};
